import type { ScrollingTickerBlock } from "@/lib/storefront-types";

type ScrollingTickerSectionProps = {
  block: ScrollingTickerBlock;
};

export function ScrollingTickerSection({
  block,
}: ScrollingTickerSectionProps) {
  const isLight = block.appearance === "light";
  const isFrozen = block.appearance === "frozen";
  const doubled = [...block.tickerItems, ...block.tickerItems];

  return (
    <section
      className={`w-full overflow-hidden border-y py-3.5 ${
        isLight
          ? "storefront-border-soft bg-[#eef6ec]"
          : isFrozen
            ? "storefront-border-primary-soft storefront-surface-frozen"
            : "border-white/8 storefront-bg-primary-dark"
      }`}
    >
      <div
        className="flex w-max gap-8 whitespace-nowrap motion-reduce:animate-none"
        style={{ animation: "content-blocks-marquee 40s linear infinite" }}
      >
        {doubled.map((item, index) => (
          <span
            key={`${item.text}-${index}`}
            className={`flex items-center gap-8 text-sm font-semibold uppercase tracking-[0.2em] ${
              isLight ? "text-[#123118]" : "text-white"
            }`}
          >
            {item.text}
            <span
              className={`h-1.5 w-1.5 rounded-full ${
                isLight ? "bg-[rgba(var(--storefront-primary-rgb),0.35)]" : "bg-white/50"
              }`}
              aria-hidden="true"
            />
          </span>
        ))}
      </div>
    </section>
  );
}
